export default [
    {
        name: "roomTexture",
        type: "texture",
        path: "textures/BakedMap2.webp",
    },
    {
        name: "room2Texture",
        type: "texture",
        path: "textures/BakedMap5.webp",
    },
    {
        name: "floorTexture",
        type: "texture",
        path: "textures/floor_4k.webp",
    },
    {
        name: "blackShinyTexture",
        type: "texture",
        path: "textures/black_shiny_2.webp",
    },
    {
        name: "backgroundMapTexture",
        type: "hdri",
        path: "textures/partly_cloudy_puresky_4k.hdr",
    },
    {
        name: "environmentMapTexture",
        type: "hdri",
        path: "textures/overcast_puresky_2k.hdr",
    },
    {
        name: "roomModel",
        type: "gltfModel",
        path: "models/InteriorDesignTJS2.glb",
    },
    {
        name: "bulbTexture",
        type: "texture",
        path: "textures/white_smooth.webp",
    },
    {
        name: "counterTexture",
        type: "texture",
        path: "textures/white_shiny.webp",
    },
    {
        name: "silverTexture",
        type: "texture",
        path: "textures/silver_shiny2.webp",
    },
    {
        name: "silverMatteTexture",
        type: "texture",
        path: "textures/silver_matte.webp",
    },
    {
        name: "goldTexture",
        type: "texture",
        path: "textures/royal_gold.webp",
    },
    {
        name: "blackMatteTexture",
        type: "texture",
        path: "textures/black_matte.webp",
    },
    {
        name: "brownMatteTexture",
        type: "texture",
        path: "textures/brown_matte.webp",
    },
];
